import { IdentityProviderDetailsState } from "@idw-types/state/identity-provider-details-state";
import { getIdentityProviderDetailsState } from "@redux/selectors/root-selectors";
import { createSelector } from "reselect";

export const getIdentityProviderDetailsReferenceDataState = createSelector(getIdentityProviderDetailsState, (state: IdentityProviderDetailsState) => {
    return state.referenceData;
});

export const getIdentityProviderDetailsDataState = createSelector(getIdentityProviderDetailsState, (state: IdentityProviderDetailsState) => {
    return {
        isLoadingIdentityProviderDetails: state.identityProviderDetails.isLoading,
        identityProviderDetails: state.identityProviderDetails.identityProviderDetails
    };
});